export function formatLabel(label) {
  const THIRTY_LETTERS = 30

  if (label.length <= THIRTY_LETTERS) return label

  const words = label.split(' ')

  if (!words.length) return label

  return groupLabelByWordCount(words)
}

function groupLabelByWordCount(words) {
  const formattedLabel = []
  let count = 0
  let piece = ''
  const TWO_WORDS = 2

  words.forEach(word => {
    piece += `${word} `

    if (count === TWO_WORDS) {
      formattedLabel.push(piece)
      piece = ''
      count = 0
    }

    count += 1
  })

  if (piece.length) formattedLabel.push(piece)

  return formattedLabel
}
